import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { _cs } from '@togglecorp/fujs';
import { genericMemo } from '../../utils/index.js';
import ElementFragments from '../ElementFragments/index.js';
import styles from './styles.css.js';

const spacingToStyleMap = {
  none: styles.noSpacing,
  compact: styles.compactSpacing,
  comfortable: styles.comfortableSpacing,
  loose: styles.looseSpacing
};
const buttonVariantToStyleMap = {
  primary: styles.primary,
  secondary: styles.secondary,
  tertiary: styles.tertiary,
  action: styles.action,
  transparent: styles.transparent,
  general: styles.general,
  'nlp-primary': styles.nlpPrimary,
  'nlp-secondary': styles.nlpSecondary,
  'nlp-tertiary': styles.nlpTertiary,
  'nlp-general': styles.nlpGeneral
};
function useButtonFeatures(props) {
  const {
    variant = 'primary',
    className,
    actionsContainerClassName,
    iconsContainerClassName,
    childrenContainerClassName,
    disabled,
    children,
    icons,
    actions,
    big,
    readOnly,
    spacing = 'comfortable',
    ellipsize
  } = props;

  const buttonClassName = _cs(styles.button, big && styles.big, readOnly && styles.readOnly, buttonVariantToStyleMap[variant] ?? styles.primary, spacingToStyleMap[spacing], ellipsize && styles.ellipsize, className);

  const buttonChildren = /*#__PURE__*/React.createElement(ElementFragments, {
    icons: icons,
    iconsContainerClassName: _cs(styles.icons, iconsContainerClassName),
    actions: actions,
    actionsContainerClassName: _cs(styles.actions, actionsContainerClassName),
    childrenContainerClassName: _cs(styles.children, childrenContainerClassName),
    spacing: spacing
  }, ellipsize ? /*#__PURE__*/React.createElement("div", {
    className: styles.ellipsizeContainer
  }, children) : children);
  return {
    className: buttonClassName,
    children: buttonChildren,
    disabled
  };
}

function Button(props) {
  const {
    variant,
    className,
    actionsContainerClassName,
    iconsContainerClassName,
    childrenContainerClassName,
    children,
    icons,
    actions,
    disabled,
    big,
    name,
    onClick,
    readOnly,
    elementRef,
    spacing,
    ellipsize,
    ...otherProps
  } = props;
  const handleButtonClick = React.useCallback(e => {
    if (onClick && !readOnly) {
      onClick(name, e);
    }
  }, [name, onClick, readOnly]);
  const buttonProps = useButtonFeatures({
    variant,
    className,
    actionsContainerClassName,
    iconsContainerClassName,
    childrenContainerClassName,
    children,
    icons,
    actions,
    disabled,
    big,
    readOnly,
    spacing,
    ellipsize
  }); // FIXME: Use raw button

  return /*#__PURE__*/React.createElement("button", _extends({
    ref: elementRef,
    type: "button",
    onClick: handleButtonClick
  }, otherProps, buttonProps));
}

var Button$1 = genericMemo(Button);

export { Button$1 as default, useButtonFeatures };
//# sourceMappingURL=index.js.map
